import React, { useState } from 'react';
import { Box, Grid, Chip, Typography } from '@mui/material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import AttachedFilesModal from './AttachedFilesModal';

// Number of files to show before collapsing into a "more" button
const FILES_TO_SHOW = 2;

function AttachmentViewer({ attachments, onOpenFilePreview }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!attachments || attachments.length === 0) {
    return null;
  }

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const visibleAttachments = attachments.slice(0, FILES_TO_SHOW);
  const hiddenAttachmentsCount = attachments.length - FILES_TO_SHOW;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Attached Files:</Typography>
      <Grid container spacing={1} alignItems="center">
        {visibleAttachments.map(attachment => (
          <Grid item key={attachment.id}>
            <Chip
              icon={<AttachmentIcon />}
              label={attachment.originalFileName}
              onClick={() => onOpenFilePreview(attachment)}
              variant="outlined"
              size="small"
              clickable
            />
          </Grid>
        ))}
        {hiddenAttachmentsCount > 0 && (
          <Grid item>
            <Chip
              label={`+ ${hiddenAttachmentsCount} more`}
              onClick={handleOpenModal}
              size="small"
              clickable
              sx={{
                cursor: 'pointer',
                backgroundColor: 'action.hover'
              }}
            />
          </Grid>
        )}
      </Grid>

      <AttachedFilesModal
        open={isModalOpen}
        onClose={handleCloseModal}
        attachments={attachments}
        onOpenFilePreview={onOpenFilePreview}
      />
    </Box>
  );
}

export default AttachmentViewer;